import React, { useState, useRef, useEffect } from 'react'
import {
  Grid, LinearProgress, MenuItem, DialogTitle, DialogContent, DialogActions,
  Button, Dialog, FormControl, InputLabel, Select,
} from '@mui/material'
import stylesheet from '../detail-container.stylesheet'
import { ClassNameMap, withStyles } from '@mui/styles'
import Draggable from "react-draggable"
import DialogTitleHeaderComponent from '../common/dialog-title-header.component'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'

interface IProps {
  open: boolean,
  item: any,
  handleDialogClose: any,
  handleSubmit: any,
  currProgram: string,
  classes: ClassNameMap
}

const AddMonitorDialogComponent: React.FC<IProps> = ({ open, item, handleDialogClose, handleSubmit, currProgram, classes }) => {
  const monitorRef = useRef(null) as any
  const [loadingMonitor, setIsLoadingMonitor] = useState(true)
  const [currMonitor, setCurrMonitor] = useState('' as any)
  const [isMonitorSubmit, setIsMonitorSubmit] = useState(false)
  const patientDetail = useSelector((state: RootState) => state.patientDetail.patientDetail)

  useEffect(() => {
    setTimeout(function () {
      setIsLoadingMonitor(false)
    }, 550);
  })

  const setSubmitData = () => {
    setIsMonitorSubmit(true)
    handleSubmit(currMonitor)
  }

  const isDisabled = (i: string): boolean => {
    const monitors = patientDetail?.medications?.monitors;
    return monitors.some((monitor: any) => monitor.name === i && monitor.programs.includes(currProgram))
  }

  return (
    <Draggable ref={monitorRef} defaultPosition={{ x: 0, y: 0 }} handle='.add-monitor-dialog'>
      <Dialog
        id={'add-monitor'}
        fullWidth={true}
        maxWidth="sm"
        open={open}
        onClose={handleDialogClose}
        aria-labelledby="Add Monitor"
        hideBackdrop
        disableScrollLock
        onKeyUp={(e) => {
          e.preventDefault();
          if (e.key === 'Enter' && !(currMonitor === '' || isMonitorSubmit))
            setSubmitData()
        }}
        sx={{
          position: "absolute",
          left: '15%',
          top: '20%'
        }}
      >
        <DialogTitle className={classes.addPatientQuestionHeaderSection} classes={{ root: 'add-monitor-dialog' }}>
          <DialogTitleHeaderComponent
            title={item?.title}
            handleDialogClose={handleDialogClose}
          />
        </DialogTitle>
        <Grid item> {loadingMonitor && <LinearProgress />} </Grid>
        <DialogContent className={classes.addPatientDialogContent}>
          <Grid container spacing={2} className={classes.containerPadding}>
            <Grid item md={12} xs={12}>
              <FormControl className={classes.formControlStage}>
                <InputLabel id="add-monitor-label" className={classes.stageLabel}>{item.label || 'Select'}</InputLabel>
                <Select
                  id="monitor"
                  labelId="add-monitor-label"
                  onChange={(e) => setCurrMonitor(e?.target?.value)}
                  label={item.label || 'Select'}
                  className={classes.programSelect}
                  inputProps={{
                    classes: {
                      icon: classes.icon,
                    },
                  }}
                >
                  {Object.keys(item?.monitorData)
                    ?.sort((a: any, b: any) => (a).toLowerCase() > (b).toLowerCase() ? 1 : -1)
                    ?.map((i: any) =>
                      <MenuItem disabled={isDisabled(i)} key={i} value={i} className={classes.programMenu}>{item?.monitorData[i]}</MenuItem>
                    )}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2} className={classes.containerPadding} justifyContent="flex-end">
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                disabled={currMonitor === '' || isMonitorSubmit}
                onClick={setSubmitData}
                component="label"
              >
                Submit
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" size="small" onClick={handleDialogClose}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </Draggable>
  );
};

export default withStyles(stylesheet)(AddMonitorDialogComponent)
